import React from 'react';

function MainHeading(props) {
  const {title,className}=props;
  return (
    <h1 className={`main-heading heading-color text-capitalize ${className}`}>{title}</h1>
  );
}

export default MainHeading;
